import { render, staticRenderFns } from "./transferee-info.html?vue&type=template&id=31b1563f&scoped=true&external"
import script from "./transferee-info.js?vue&type=script&lang=js&external"
export * from "./transferee-info.js?vue&type=script&lang=js&external"
import style0 from "./transferee-info.scss?vue&type=style&index=0&id=31b1563f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b1563f",
  null
  
)

export default component.exports